import React from "react";
import "./logo.css";

function Logo() {
  return <h1 className="logo">Rusty Crow</h1>;
}

export default Logo;
